import React, {Component} from 'react';
import {Link} from 'react-router-dom';

// Import Images
import bnrImg1 from "../../images/banner/img1.jpg";
// import waveBlue from "../../images/shap/wave-blue.png";
// import circleDots from "../../images/shap/circle-dots.png";
// import plusBlue from "../../images/shap/plus-blue.png";

import AppointmentForm from '../elements/appointment-form';

class Booking extends Component{
	
	render(){
		return (
			<>
				
				<div className="page-content bg-white">
					
					<div className="banner-wraper">
						<div className="page-banner" style={{backgroundImage: "url("+bnrImg1+")"}}>
							<div className="container">
								<div className="page-banner-entry text-center">
									<h1>Booking</h1>
									{/* <nav aria-label="breadcrumb" className="breadcrumb-row">
										<ul className="breadcrumb">
											<li className="breadcrumb-item"><Link to="/"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-home"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg> Home</Link></li>
											<li className="breadcrumb-item active" aria-current="page">Booking</li>
										</ul>
									</nav> */}
								</div>
							</div>
							{/* <img className="pt-img1 animate-wave" src={waveBlue} alt=""/>
							<img className="pt-img2 animate2" src={circleDots} alt=""/>
							<img className="pt-img3 animate-rotate" src={plusBlue} alt=""/> */}
						</div>
					</div>
				
					<section className="section-area section-sp2 appointment-wraper">
						<div className="container">
							<div className="row justify-content-center">
								<div className="col-xl-5 col-lg-6 col-md-6">
									
									<AppointmentForm />
									
								</div>
								<div className="col-12">
									<div className="widget">										
										<h5 className="title-head">Fill Out Our Forms Here!</h5>
										<ul className="service-menu">
											<li><Link to="https://forms.wv3.io/form?formId=06e94363-66d2-4e2c-bfb7-d23726889a5b&companyId=1e664556-4582-4516-8686-98fa232fe853"><span>Health History Form English</span><i className="fa fa-angle-right"></i></Link></li>
											<li><Link to="https://forms.wv3.io/form?formId=a08ebbd6-8b00-44f7-b7c1-5e74dd180fd1&companyId=1e664556-4582-4516-8686-98fa232fe853"><span>Health History Form Spanish</span><i className="fa fa-angle-right"></i></Link></li>										
										</ul>											
									</div>
								</div>
							</div>

						</div>
						
					</section>
					
				</div>
			
			</>
		);
	}
}

export default Booking;